/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react'
import _ from 'lodash'
import { colors } from '@lmc/common/constants'
import { getJSON } from '../../../common/services/api'
import { ProfileLink } from '../../../components/generic'
import { Link } from 'react-router-dom'
import { ButtonOLD } from '@lmc/ui-kit'
import Glyph from '../../../LEGACY/Glyph'
import { CardTitle } from './CardComponents'

const TITLE = 'Family Portal'

type Profile = any

type Data = {
  result: {
    activeAccounts: any
    seenRecently: unknown[]
    invited: boolean
  }
}

type Response = {
  data: Data
}

const getBodyText = (seenRecently: number, invited: boolean) => {
  if (!invited)
    return <p>You`re all set up, but no family members have been invited yet</p>
  if (!seenRecently)
    return (
      <p>
        It doesn’t look like any family members have been active recently (last
        24 hrs)
      </p>
    )
  if (seenRecently === 1) {
    return (
      <p>
        <strong>One family member</strong> has been active recently (last 24h)
      </p>
    )
  }
  return (
    <p>
      <strong>{seenRecently} family members</strong> have been active recently
      (last 24h)
    </p>
  )
}

const Body = ({ data }: Response) => {
  const [nShowing, showMore] = useState(10)
  if (!data) return null
  return (
    <div>
      <p>
        Active{' '}
        <span style={{ marginRight: 12, color: colors.darkgrey }}>
          ({data?.result?.activeAccounts || 0})
        </span>
        Sent Invite{' '}
        <span style={{ marginRight: 12, color: colors.darkgrey }}>
          ({data?.result?.invited || 0})
        </span>
      </p>
      {getBodyText(data?.result?.seenRecently?.length, data?.result?.invited)}
      <div className="lmc-flex-grid">
        {_.take(data?.result?.seenRecently || [], nShowing).map(
          (profile: Profile) => (
            <ProfileLink
              key={profile.id}
              list="residents"
              id={profile.resident}
              name={profile.name}
              picture={profile.picture}
            />
          )
        )}
        {data?.result?.seenRecently?.length > nShowing ? (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a className="lmc-more-link" onClick={() => showMore(nShowing + 30)}>
            More...
          </a>
        ) : null}
      </div>
    </div>
  )
}

const Footer = () => (
  <div className="lmc-home-card-footer">
    <div style={styles.footer}>
      <div />
      <Link to="/settings/family-invite">
        <ButtonOLD
          type="primary"
          icon={
            <Glyph
              name="mail"
              aphroditeStyles={undefined}
              className={undefined}
              color={undefined}
              component={undefined}
              size={undefined}
              style={undefined}
            />
          }
        >
          Invite a Family Member
        </ButtonOLD>
      </Link>
    </div>
  </div>
)

const FamilyCard = () => {
  const [data, setData] = useState()

  useEffect(() => {
    getJSON({ url: `/api/list/carers/family-status` }).then(setData)
  }, [])

  return (
    <div>
      <div className="lmc-home-card" style={styles.card}>
        <CardTitle title={TITLE} />
        <div className="lmc-home-card-body-ss">
          <Body data={data as unknown as Data} />
        </div>
        <Footer />
      </div>
    </div>
  )
}

const styles = {
  card: {
    overflow: 'hidden',
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}

export default FamilyCard
